const modal_confirm_change_tab = {
  title: 'You have unsaved changes',
  subtitle: 'By confirming , you will lose all unsaved changes',
  cancel: 'Cancel',
  confirm: 'Confirm',
}

export default modal_confirm_change_tab
